import { WriterPublisherPage } from './WriterPublisherPage'
import { withWriterPublisherPage } from './withWriterPublisherPage'

const Connected = withWriterPublisherPage(WriterPublisherPage)

export { Connected as WriterPublisherPage }
